
export default {
	name: 'basicCard',
	data() {
		return {}
	},
	props: {
		goods: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	created() {
		// console.log(this.goods)
	},
	methods: {}
}
